import React, { useState, useEffect, useContext, useRef } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "../../style.css";
import "./sourcecode-audit.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { SetredirectValue } from "../../../../Store/PageredirectSlice";
import highSeverityIcon from "../../Asset/esocardicon/SourceCodeAudit/highSeverity.svg"
import mediumSeverityIcon from "../../Asset/esocardicon/SourceCodeAudit/mediumSeverity.svg"
import lowSeverityIcon from "../../Asset/esocardicon/SourceCodeAudit/lowSeverity.svg"
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../../Rightsidebar/Rightsidebar";
import { Commonfun, datezonechange, timezoneval, timezonechange } from '../../Commonfun';
import { AppContext } from "../../../../Context/Context";
import { Utils } from "../../../../Utils/Utils";
import Freeaudit from "../../../../Utils/Freeaudit";
import Loader from "../../CommonLoader";
import CommonAlert from "../../../../Commonalert/commonalert";
import DatagridComp from "../../DatagridComp";
// import PdfandCsv from "../PdfandCsv";
import CommonBreadCrumb from "../../../../Commonalert/commonbreadcrumb";
import { Card, Container, Grid, Typography } from '@mui/material';
import ErrorCount from "../../Asset/esocardicon/SchemaDetail/ErrorCount.svg"
import Commoncard from "../../Commoncard";
import { customDropdownStyles } from "../../../../Commonalert/commonDropdown";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import UserActivityTracker from "../../../../hooks/userActivityTracker";
import ScoreGauge from "../../../../Components/chart/gaugeChart";
import Chart from "react-apexcharts";
import { DataGrid } from "@mui/x-data-grid";



export default function SourceCodeAudit() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [jobId, setJobId] = useState("");
  const [notifycount, setNotifycount] = useState("");
  const [topActionItemPlan, settopActionItemPlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [severityCounts, setSeverityCounts] = useState({
    low: 0,
    medium: 0,
    high: 0
  });
  const [isCodePopup, setIsCodePopup] = useState(false);
  const [rowCode, setRowCode] = useState([]);

  //filter
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedJobDate, setSelectedJobDate] = useState(null);
  const [prevSelectedJobDate, setPrevSelectedJobDate] = useState(null);
  const [jobDateOptions, setJobDateOptions] = useState([]);
  //run report
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [successApiopen, setSuccessApiOpen] = useState(false);
  const [successApierrorMsg, setSucessApierrorMsg] = useState('');
  const [aiMap, setAiMap] = useState({});
  const [isAiPopup, setIsAiPopup] = useState(false);
  const [selectedAiSuggestion, setSelectedAiSuggestion] = useState("");
  const [summaryData, setSummaryData] = useState({
    "code_security_score": 0,
    "severity_distribution": {
      "high": 0,
      "medium": 0,
      "low": 0
    },
    "historical_trend": [],
    "top_5_vulnerable_files": []
  });
  const navigate = useNavigate()

  const checkUserPlan = async () => {
    // const topActionItemP = await Utils("top_action_items", ApiToken);
    const topActionItemP = { status: true, error: "" };
    if (topActionItemP.status) {
      callUserdataApi();
      faqdatafun();
    }
    settopActionItemPlan(topActionItemP);
  };

  useEffect(() => {
    checkUserPlan();
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const jobDOptions = await axios
        .get(
          `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=security_audit&audit_type=file_audit`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (jobDOptions.data.jobs) {
        var Sections = [];

        jobDOptions.data.jobs.forEach((element) => {
          Sections.push({
            label: datezonechange(element.completed_at),
            value: element.id
          });
        });

        setJobDateOptions(Sections);

        if (Sections.length > 0) {
          setSelectedJobDate(Sections[0]);
          setPrevSelectedJobDate(Sections[0]);
          setJobId(Sections[0].value);

          // callUserdataApi(Sections[0].value);
        }
      }
    } catch (err) { }
  };

  const columns = [
    {
      field: "filename",
      headerName: "File Name",
      description: 'The name of the file where the security vulnerability was detected.',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "issue_text",
      headerName: "Issue text",
      description: 'A brief description of the security issue found in the file.',
      minWidth: 320,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "issue_severity",
      headerName: "Issue Severity",
      description: 'The severity of the security vulnerability',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "View",
      headerName: "Action",
      description: 'Click to view the detailed report',
      minWidth: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      headerClassName: "hide_option",
      renderCell: (cardData) => {
        return (
          // <a href={detailurl + `${cardData.row.id}` + "/" + `${jobId}`}>
          // <a href={'blank'}>
          <button className="view-report-button" onClick={() => { setRowCode(cardData.row.code); setIsCodePopup(true); }}>View Code</button>
          // </a>
        );
      },
    },
    {
      field: "ai_suggestion",
      headerName: "AI Suggestion",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      description: "SEO-optimized anchor text ideas generated by AI to improve your ranking for target keywords.",
      renderCell: (params) => {
        const rowId = params.row.sid;
        const aiData = aiMap[rowId];

        if (aiData?.loading) {
          return <span style={{ fontSize: "12px" }}>Loading...</span>;
        }

        // if (aiData?.data) {
        //   return (
        //     <button
        //       className="view-report-button"
        //       onClick={() => {
        //         setSelectedAiSuggestion(aiData.data);
        //         setIsAiPopup(true);
        //       }}
        //     >
        //       View Suggestion
        //     </button>
        //   );
        // }

        return (
          <button
            className="ai-btn"
            onClick={() => fetchAiSuggestion(params.row)}
          >
            Suggestion
          </button>
        );
      },
    }

  ];

  const rows = cardData ?? [];


  const callUserdataApi = async (jobId = "") => {
    setLoading(true);
    setTableLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}security_tools/file_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}&formats=''&timezone=''`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        if (error?.response?.data?.security_config) {
          const securityError = <div dangerouslySetInnerHTML={{ __html: error?.response?.data?.security_config }} />
          setapierrorMsg(securityError);
        } else {
          setapierrorMsg(error?.response?.data?.error)
        }
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    if (datavalue?.data.detail && datavalue?.data?.detail.length > 0) {
      const dataval = datavalue?.data?.detail;
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      setSeverityCounts(datavalue?.data?.severity_counts);
      SetAutoheightval(false)

      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);
    }
    else {
      SetAutoheightval(true)
      setCardData("");
    }

    if (datavalue?.data) {
      const newData1 = (datavalue?.data?.charts?.top_5_vulnerable_files || []).map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setSummaryData({
        "code_security_score": datavalue?.data?.charts?.code_security_score || 0,
        "severity_distribution": {
          "high": datavalue?.data?.charts?.severity_distribution?.high || 0,
          "medium": datavalue?.data?.charts?.severity_distribution?.medium || 0,
          "low": datavalue?.data?.charts?.severity_distribution?.low || 0
        },
        "historical_trend": datavalue?.data?.charts?.historical_trend || [],
        "top_5_vulnerable_files": newData1 || []
      })
    }

    setTableLoading(false);
    setLoading(false);
  };


  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/file_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&timezone=${timezoneval()}&job_id=${jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("SourceCodeAudit", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }

  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/file_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&timezone=${timezoneval()}&job_id=${jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'sourcecodeaudit.csv';

        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=72`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const fetchAiSuggestion = async (row) => {
    const rowId = row.sid;
    setAiMap((prev) => ({ ...prev, [rowId]: { loading: true, data: "" } }));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}security_tools/file_audit_ai/`,
        { id: row.sid, job_id: jobId },
        { headers: { Authorization: `${ApiToken}` } }
      );

      const suggestion = response.data.suggestion;
      setAiMap((prev) => ({
        ...prev,
        [rowId]: { loading: false, data: suggestion },
      }));

      setSelectedAiSuggestion(suggestion);
      setIsAiPopup(true);

    } catch (error) {
      setAiMap((prev) => ({
        ...prev,
        [rowId]: { loading: false, data: "Failed to fetch suggestion" },
      }));
    }
  };

  const cardDatas = [
    {

      value: severityCounts.high || 0,
      title: "High Severity",
      // badge: "SEO",
      iconSrc: highSeverityIcon,
      iconColor: 1,
      bgColor: 1,

    },
    {
      value: severityCounts.medium || 0,
      title: "Medium Severity",
      // badge: "TRAFFIC",
      iconSrc: mediumSeverityIcon,
      iconColor: 2,
      bgColor: 2,
    },
    {
      value: severityCounts.low || 0,
      title: "Low Severity",
      // badge: "TRAFFIC",
      iconSrc: lowSeverityIcon,
      iconColor: 3,
      bgColor: 3,
    },

  ];

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleModelPopUp = () => {
    openModal();
  }

  function openModal() {
    setIsFilterOpen(true);
  }

  function closeModal() {
    setIsFilterOpen(false);
    setSelectedJobDate(prevSelectedJobDate);
  }

  // const filterNow = () => {
  //   const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
  //   callUserdataApi(jobId);
  //   setPrevSelectedJobDate(jobId);
  //   setIsFilterOpen(false);
  // }

  const filterNow = () => {
    const selected = selectedJobDate ? selectedJobDate.value : "";

    setJobId(selected);
    callUserdataApi(selected);
    setPrevSelectedJobDate(selectedJobDate);
    setIsFilterOpen(false);
  };

  const handleReset = () => {
    setSelectedJobDate(null);
  }

  //Run report

  const closeRunReport = () => {
    setIsReportOpen(false);
  }

  const runReportNow = async () => {
    setLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}security_tools/run_security_report/?user_domain_id=${esodata.domaindata.value.header_selected}&report_type=file_audit`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    if (datavalue?.status === 200) {
      setSuccessApiOpen(true);
      setSucessApierrorMsg(datavalue?.data?.success);
    }

    setIsReportOpen(false);
    setLoading(false);
  };

  const successApiClose = () => {
    setSuccessApiOpen(false);
  }

  const closeTracePopup = () => {
    setIsCodePopup(false);
  }

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const txtToHtml = (text) => {
    console.log('text', text);
    const htmlString = text.replace(/\/n/g, "<br/>");
    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: htmlString }} />
      </div>
    )
  }

  const gaugeChart = () => {
    return (
      <div>
        {/* <span>Most Critical issue category</span> */}
        <ScoreGauge score={summaryData.code_security_score} width={'350px'} />
      </div>
    )
  }

  const urls = Array.isArray(summaryData?.historical_trend)
    ? summaryData.historical_trend
    : [];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true, // better for long URLs
        barHeight: "60%"
      }
    },
    xaxis: {
      categories: urls?.map(item => item.date) || [],
      labels: {
        offsetX: 50 // 👈 manual adjustment
      }
      // labels: {
      //   show: true   // 👈 hides numbers/text on x-axis
      // },
      // axisBorder: {
      //   show: false   // optional: remove axis line
      // },
      // axisTicks: {
      //   show: false   // optional: remove ticks
      // }
    },
    yaxis: {
      labels: {
        maxWidth: 150
      }
    },
    grid: {
      padding: {
        left: 20,
        right: 20
      }
    },
    tooltip: {
      x: {
        formatter: (val, opts) => urls[opts.dataPointIndex]?.date
      },
      y: {
        formatter: (val) => val
      }
    }
  };

  const chartSeries = [
    {
      name: "High",
      data: urls?.map(item => item.high) || []
    },
    {
      name: "Medium",
      data: urls?.map(item => item.medium) || []
    },
    {
      name: "Low",
      data: urls?.map(item => item.low) || []
    }
  ];

  const cardDatas1 = [
    {
      value: summaryData.code_security_score || 0,
      title: "Code Security Score",
      iconSrc: highSeverityIcon,
      iconColor: 1,
      bgColor: 1,
    }
  ];

  // const columns1 = [
  //   {
  //     field: "filename",
  //     headerName: "File Name",
  //     description: 'The name of the file where the security vulnerability was detected.',
  //     minWidth: 150,
  //     flex: 1,
  //     headerAlign: 'center',
  //     align: 'center',
  //     sortable: true
  //   },
  //   {
  //     field: "issue_severity",
  //     headerName: "Issue Severity",
  //     description: 'The severity of the security vulnerability',
  //     minWidth: 150,
  //     flex: 1,
  //     headerAlign: 'center',
  //     align: 'center',
  //     sortable: true,
  //   }
  // ]

  return (
    <div className={`over_all_container top_action_list ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Source Code Audit</title>
      </Helmet>

      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Source Code Audit
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Security Tools', activeColor: false },
                      { title: 'Source Code Audit', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                <button
                  title="Security Audit Settings"
                  className="btn_dashboard"
                  onClick={() => navigate('/security-audit-settings')}
                >
                  Security Audit Settings
                </button>
                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => setIsReportOpen(true)}
                // onClick={() => {
                //   if (first.statusDomain) {
                //     setcheckD(first.statusDomain);
                //   } else {

                //     setfaqData(2);
                //     setToggle(false);
                //     SetRunReportPopShow(true);
                //   }
                // }}
                // disabled={!analysisSummaryPlan.status}
                >
                  Run Report Now
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} className="dashboard-card-container">
        <Box >
          <Grid container className="dashboard-box-card">
            <Grid container spacing={3} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={item.id}>
                  <Commoncard
                    item={item}
                    nonclikable={true}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px', alignItems: "center" }}>

          {/* <Grid item xs={12} sm={12} md={3}>
            <Card
              sx={{
                borderRadius: "16px",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                transition: "0.3s",
                cursor: "default",
                height: "100%",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                },
                overflow: "hidden",
                border: "none"
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#d1fae5',
                  p: 2.5,
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >

                <Box
                  sx={{
                    color: "#059669",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                  }}
                >
                  {gaugeChart()}
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    fontSize: "2.5rem",
                    background: "linear-gradient(to right, #1f2937, #4b5563)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                    letterSpacing: 1,
                  }}
                >
                  <div style={{ justifySelf: 'center', marginTop: '1rem' }}>{summaryData.code_security_score}<span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span></div>
                </Typography>
              </Box>

              <Box
                sx={{
                  background: "#fff",
                  px: 2.5,
                  py: 3,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textTransform: "uppercase",
                }}
              >
                <Typography
                  sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                >
                  Code Security Score
                </Typography>
              </Box>
            </Card>
          </Grid> */}

          <Grid container spacing={3} item xs={12} md={3} justifyContent="center">
            {cardDatas1.map((item, index) => (
              <Grid item xs={12} sm={12} md={12} key={item.id}>
                <Commoncard
                  item={item}
                  nonclikable={true}
                />
              </Grid>
            ))}
            <Grid item xs={12} md={12}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '230px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Severity Distribution</Typography>
                <Chart
                  type="donut"
                  height={210}
                  series={Object.values(summaryData.severity_distribution)}
                  options={{
                    labels: Object.keys(summaryData.severity_distribution),
                    legend: { position: 'bottom', fontSize: '10px' },
                    dataLabels: { enabled: false }
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Historical Trend</Typography>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
                height={360}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <div className="top5vulnerable-card">
              <div className="top5vulnerable-title-main">Top 5 Vulnerable Files</div>

              <div className="top5vulnerable-table">
                <div className="top5vulnerable-header">
                  <div>File Name</div>
                  <div>Issue Severity</div>
                </div>

                <div className="top5vulnerable-body">
                  {summaryData?.top_5_vulnerable_files.length > 0 ?
                    <>
                      {summaryData?.top_5_vulnerable_files?.map((item, index) => (
                        <div className="top5vulnerable-row" key={index}>
                          <div className="top5vulnerable-filename">{item.filename}</div>

                          <div
                            className={`top5vulnerable-badge ${item.issue_severity?.toLowerCase()}`}
                          >
                            {item.issue_severity}
                          </div>
                        </div>
                      ))}
                    </> :
                    <div className="top5vulnerable-nodata">No Data Available</div>
                  }
                </div>
              </div>
            </div>
          </Grid>

          {/* <Grid item xs={12} md={4}>
            <DataGrid
              className="datagrid_custom_scroll"
              columns={columns1}
              rows={summaryData.top_5_vulnerable_files}
              autoheightval={false}
              getRowId={((row) => row.sid)}
              pagination={false}
              slots={{
                footer: () => { }
              }}
            />
          </Grid> */}

        </Grid>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {topActionItemPlan.status ?
                  <DatagridComp className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={true}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                  : <Freeaudit planStatus={topActionItemPlan} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <div className="cnt_audit_outer_wrap">
        <div >
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        </div>
        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      </div>


      <Dialog
        open={isFilterOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Filter By"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">
              <div>
                <div >
                  <div>
                    <span className="select_filter_text">Completed Date</span>
                    <Select
                      value={selectedJobDate}
                      options={jobDateOptions}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectedJobDate(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={filterNow}
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeModal}>
            close
          </button>
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isReportOpen}
        onClose={closeRunReport}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Run Report"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div>
              Can we run the report for File Audit ?
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={runReportNow}
            style={{ cursor: "pointer" }}
          >
            Run
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeRunReport}>
            Cancel
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isCodePopup}
        onClose={closeTracePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Code's"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {rowCode.map(code => {
                return (
                  <div>
                    {code}
                  </div>
                );
              })}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button style={{ cursor: "pointer" }} onClick={closeTracePopup}>
            Close
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isAiPopup}
        onClose={() => setIsAiPopup(false)}
        aria-labelledby="ai-suggestion-title"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header">
          {"AI Suggestion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="ai-suggestion-description">
            <div style={{
              maxHeight: "400px",
              overflowY: "auto",
              backgroundColor: "#f9f9f9",
              padding: "15px",
              borderRadius: "4px",
              border: "1px solid #ddd"
            }}>
              <pre style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                margin: 0,
                fontFamily: 'inherit',
                fontSize: '14px',
                color: '#333'
              }}>
                {selectedAiSuggestion}
              </pre>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button style={{ cursor: "pointer" }} onClick={() => setIsAiPopup(false)}>
            Close
          </button>
        </DialogActions>
      </Dialog>

      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true
        }}
        closeAlert={apihandleClose} />

      <CommonErrorAlert
        data={{
          apiopen: successApiopen,
          apiErrorMsg: successApierrorMsg,
          isIconStyled: false
        }}
        closeAlert={successApiClose} />
      <UserActivityTracker pagename="Security Tools - Source Code Audit" />

    </div>
  );
}
